import React, { useState } from "react";
import MyMap from "../../Maps/MyMap";
import MapIcon from "../../../assets/icons/mapping.svg2";
import { AbsoluteLoadingIndicator } from "../FullScreenLoadingIndicator";
import HelpButton from "../../HelpContent/HelpButton";
import WeatherAlerts from "../../Maps/WeatherAlerts";

const filters = {
  isWeather: false,
  showGrids: false,
  StartAt: "",
  EndAt: "",
  range: -1,
  period: "daily",
  alertFilters: {
    ruleID: undefined,
    conditionIds: [],
    conditions: [],
    search: "",
  },
};

export default function LiveEventsMapWidget() {
  const [loading, setLoading] = useState(false);

  return (
    <div className="h-100 p-3 rounded-3">
      <AbsoluteLoadingIndicator loading={loading} />

      <div className="card-body d-flex flex-column justify-content-between h-100">
        <div className="text-white ">
          <MapIcon width={20} className="me-2 white opacity-50" />
          <span className="small fw-bold widget-header">LIVE EVENTS MAP</span>
          <HelpButton helpKey="widget-live-events-map" iconClassName="white" />
        </div>
        <hr className="text-white my-2" />
        <MyMap mapTypeControl={false}>
          <WeatherAlerts
            filters={filters}
            // setOverlay={setOverlay}
            setLoading={setLoading}
          />{" "}
        </MyMap>
      </div>
    </div>
  );
}
